export enum MutationTypes {
  SET_IS_EXPAND = 'SET_IS_EXPAND',
}
